function Row({ items, hidden = false }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((it, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-2xl font-bold tracking-tight text-slate-400/60 md:px-12 md:text-4xl">
            {it}
          </span>
          <span className="h-2 w-2 shrink-0 rounded-full bg-aurora/60" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee({ items }) {
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/5 py-7 md:py-9">
      <div className="animate-marquee flex w-max">
        <Row items={items} />
        <Row items={items} hidden />
      </div>
    </div>
  );
}
